import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c75f811a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "操作提示："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "商品栏目能很方便的聚合商品荐列表。"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "商品栏目在首页、购物车、个人中心显示，可任意删除，请谨慎操作。")
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("隐藏")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("不显示")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "商品栏目" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "栏目名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.name) = $event)),
                  placeholder: "请输入栏目名称",
                  style: {"width":"200px"}
                }, null, 8, ["value"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: _ctx.getList
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, { style: {"margin-left":"10px"} }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          onChange: _ctx.handleTableChange,
          columns: _ctx.columns,
          pagination: _ctx.pagination,
          loading: _ctx.loading,
          bordered: "",
          style: {"margin-top":"10px"},
          rowKey: record=>record.id
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.status == 1 )
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "#2db7f5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (record.status !== 1 )
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 1,
                        color: "#f50"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该分类?",
                    onConfirm: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "onChange", "columns", "pagination", "loading", "rowKey"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOk('formRef'))),
      width: "30%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: _ctx.rules,
          model: _ctx.form,
          "label-col": { span: 3 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "栏目名称",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                  placeholder: "请输入栏目名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "栏目描述",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.remark,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.remark) = $event)),
                  placeholder: "请输入栏目描述"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "排序",
              name: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.form.sort,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.sort) = $event)),
                  placeholder: "请输入单位名"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "是否显示",
              name: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.form.status,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "on" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "off" }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}